export default __webpack_public_path__ + "static/media/store-appearance-phone-toggle.92ce6557.svg";